module.exports = __webpack_public_path__ + "img/28-1-2023_raices.8b54fe53.jpeg";